import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { merchantCardCallout } from "../../../constants/app";
import { Container, CardCallout } from "../../_global";
import { merchantProps } from "../Detail/merchantProps";
import { MerchantLogo, Banner } from "../Style/index";
var ResponsiveLogo = /*#__PURE__*/function (_Component) {
  function ResponsiveLogo(props) {
    var _this;
    _classCallCheck(this, ResponsiveLogo);
    _this = _callSuper(this, ResponsiveLogo, [props]);
    _this.renderLogo = function (merchant, calloutCopy) {
      return __jsx(MerchantLogo, null, __jsx("img", {
        src: merchant.merchantLogoSquare,
        alt: "".concat(merchant.merchantName, "'s online shopping"),
        itemProp: "logo"
      }), calloutCopy && __jsx(CardCallout, {
        isLogo: true,
        callType: calloutCopy.split(' ')[0]
      }, calloutCopy));
    };
    _this.state = {};
    return _this;
  }
  _inherits(ResponsiveLogo, _Component);
  return _createClass(ResponsiveLogo, [{
    key: "render",
    value: function render() {
      var merchant = this.props.merchant;
      var calloutCopy = merchantCardCallout(merchant);
      return __jsx(React.Fragment, null, __jsx(Banner, {
        src: merchant.merchantHero,
        alt: "".concat(merchant.merchantName, "'s banner")
      }), __jsx(Container, {
        wideView: true
      }, this.renderLogo(merchant, calloutCopy)));
    }
  }]);
}(Component);
export default ResponsiveLogo;